export default {
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  navbar: {
    changeLang: '切换语言',
    screenfull: '全屏',
    theme: '换肤'
  },
  dropDownMenu: {
    personal: '个人中心',
    setting: '设置',
    modifyPassword: '修改密码',
    sign_out: '注销'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  login: {
    system_login: '系统登录',
    member_login: '会员登录',
    username: '请输入登录名',
    phone: '请输入手机号',
    loginName: '请输入手机号或登录名',
    password: '请输入密码',
    login: '登 录'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  errorCode: {
    '1000000': '用户名或密码错误',
    'default': '系统未知错误,请反馈给管理员'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  button: {
    add: '添加',
    export: '导出',
    import: '导入',
    edit: '编辑',
    delete: '删除',
    'batch-delete': '批量删除',
    enable: '启用',
    disable: '禁用',
    search: '查询',
    clear: '清空',
    confirm: '确定',
    cancel: '取消',
    show: '查看',
    close: '关闭',
    back: '返回',
    update: '修改',
    preview: '预览',
    'batch-close': '批量关闭',
    findSupplement: '任务内容',
    findResult: '诊断结果',
    inquiryList: '问诊列表',
    updateRank: '更新积分榜'
  },
  column: {
    index: '序号',
    actionCode: '权限编码',
    actionName: '权限名称',
    status: '状态',
    url: '权限地址',
    remark: '备注',
    operate: '操作',
    actionGroupName: '权限分类名称',
    actionGroupCode: '权限分类编码'
  },
  radio: {
    enable: '启用',
    disable: '禁用'
  },
  tips: {
    tooltip: '提示'
  },
  message: {
    selectOne: '请选择一条数据！',
    selectOneOrMore: '请选择一条或者多条数据！',
    selectStore: '请选择一个门店'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js